// extracted by mini-css-extract-plugin
export default {"whiteButton":"whiteButton_whiteButton__APT44","whiteButtonText":"whiteButton_whiteButtonText__OFs62","whiteButtonImg":"whiteButton_whiteButtonImg__GWfJQ"};